import React, { Component } from 'react';
import styled from 'styled-components';

import { Font } from '../../../../utils/fonts';
import Color from '../../../../utils/colors';
import mediaWidth from '../../../../utils/mediaWidth/mediaWidth';

import arrow from '../../assets/arrow.svg';

class MobileForwardButton extends Component {
    render() {
        const { className, handleClick } = this.props;
        return (
            <Root className={className} onClick={handleClick ? () => handleClick() : null}>
                <Text>
                    <Mobile>далее</Mobile>
                    <Desktop>на главную</Desktop>
                </Text>
                <Arrow />
            </Root>
        );
    }
}

const Mobile = styled.div`
    ${mediaWidth.l} {
        display: none;
    };
`;

const Desktop = styled.div`
    display: none;
    ${mediaWidth.l} {
        display: block;
    };
`;

const Arrow = styled.div`
    width: 5px;
    height: 9px;
    background-size: cover;
    background-image: url(${arrow});
`;

const Text = styled.div`
    margin-right: 8px;
    ${Font.HEADLINE};
    font-weight: 500;
    font-size: 12px;
    line-height: 14px;
    text-transform: uppercase;
    color: ${Color.TEXT_PRIMARY};

    ${mediaWidth.m} {
        margin-right: 12px;
        font-size: 16px;
        line-height: 19px;
    };
`;

const Root = styled.button`
    display: flex;
    align-items: center;
    background: unset;
    border: none;
    outline: none;

    -webkit-tap-highlight-color: transparent;
`;

export default MobileForwardButton;
